import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';

// SESSION 46: Dynamic language from user preference (not build-time env var)
const savedLanguage = localStorage.getItem('userLanguage') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru }
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

/**
 * Change UI language + persist to localStorage + sync to backend.
 * Call this from LanguageSwitcher component.
 */
export async function changeLanguage(lng) {
  i18n.changeLanguage(lng);
  localStorage.setItem('userLanguage', lng);

  // Fire-and-forget API call to persist in user profile
  const token = localStorage.getItem('token');
  if (token) {
    try {
      const API = process.env.REACT_APP_BACKEND_URL || '';
      fetch(`${API}/api/auth/language`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ language: lng })
      }).catch(() => {}); // silently ignore network errors
    } catch (e) {
      // ignore
    }
  }
}

export default i18n;
